import { AdditionalField } from './additional-field';

export class ActivitiesConfig {
  constructor(public additionalFields: AdditionalField[]) {}
}
